<template>
    <div>

        <div class="mission-statement">

            <video v-if="showPlaceholder" style="width: 100%; height: 100%;" playsinline poster="https://mcaloon.org/firstFrame.png">                    
            </video>

            <video v-if="showVideo" style="min-height:100%" playsinline autoplay poster="https://mcaloon.org/firstFrame.png" id="bgvid" @play="onStart()" @ended="onEnd()">
                <source src="https://mcaloon.org/c5a0fb5cf20768bb45e4720ec84df0de8fbfc550f2615024d37968b7bc7603e6.mp4" type="video/mp4">
            </video>

            <!-- text overlay -->
            <div class="text-background" :class="[showStartTextOverlay ? '' : 'animate__animated animate__fadeOut']">
                <div v-if="showStartText" class="video-overlay-text animate__animated animate__fadeIn" :class="[hideStartText ? 'animate__animated animate__fadeOut' : '']">
                    Your genetic pack is being cryopreserved and protected by Vitrafy.
                </div>
            </div>              

            <div v-if="showEndTextOverlay" class="text-background animate__animated animate__fadeIn">
                <div v-if="showEndText" class="video-overlay-text animate__animated animate__fadeIn">
                    Protected by Vitrafy. Ready for storage.
                </div>
            </div>     

        </div>

    </div>
</template>

<script>
    export default {
        name: 'NFTVideoTestFullScreen',
        components: {
        },
        data: function () {
            return {
                test: 'test 123',
                showStartTextOverlay: true,
                showStartText: false,
                hideStartText: false,
                showPlaceholder: true,
                showVideo: false,
                showEndTextOverlay: false,
                showEndText: false,                                     
            }
        },
        computed: {},
        props: [],
        watch: {

        },
        methods: {
            onStart: function() {
                console.log('Video Started');
                setTimeout(() => {
                    this.showEndTextOverlay = true;              
                }, 25000);
                
                setTimeout(() => {
                    this.showEndText = true;              
                }, 26000);                       
            },
            onEnd: function () {
                console.log('Video Ended');
            }            
        },
        mounted: function () {
            // Display core vue app element
            const appElement = document.getElementById('app');
            appElement.style.display = 'block';            
        },
        created() {
            // initial state
            this.showStartTextOverlay = true;
            this.showStartText = false;
            this.hideStartText = false;
            this.showPlaceholder = true;
            this.showVideo = false;
            this.showEndTextOverlay = false;
            this.showEndText = false;  

            // show text after 1 second
            setTimeout(() => {
                this.showStartText = true;
            }, 1000);

            // hide text after 4 seconds
            setTimeout(() => {
                this.hideStartText = true;
            }, 4000);            
                            
            // hide first text overlay after 3 seconds
            setTimeout(() => {
                this.showStartTextOverlay = false;              
            }, 5000);

            // start video after 2 seconds
            setTimeout(() => {
                this.showVideo = true;       
                this.showPlaceholder = false;
            }, 3000);           
        }
    }
</script>

<style>
    .nft-notification:hover {
        color: var(--bs-dropdown-link-hover-color);
        background-color: var(--bs-dropdown-link-hover-bg);        
    }

    * {
        margin: 0;
        padding: 0;
        border: 0;
        box-sizing: border-box;
    }

    html,
    body {
        height: 100%;
        width: 100%;
    }

    #mission-statement {
        position: relative;
        overflow: hidden;
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
    }

    video#bgvid {
        height: 100vh;
        width: 100vw;
        object-fit: cover;
        overflow: hidden;
        position: absolute;
        bottom: 0;
        right: 0;
    }

    #video-modal-1 > .modal-dialog {
        margin-top: 0;
        margin-bottom: 0;
    }

    #video-modal-1___BV_modal_header_ {
        display: none;
    }

    #video-modal-1___BV_modal_body_ {
        padding: 0;
    }

    #video-modal-1___BV_modal_footer_ {
        display: none;
    }

    .modal-fullscreen .modal-dialog {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100vh;
        display: flex;
        position: fixed;
        z-index: 100000;
    }    
   

    .text-background {
        position: absolute;
        top: 0;
        left: 0;   
        width: 100%;
        height: 100%;
        background-color: #fff;
    }

    .video-overlay-text {
        position: absolute;
        width: 100%;
        background-color: #fff;
        top: 37%;
        left: 0;
        text-align: center;
        font-size: 32px;
        padding: 30px;
    }

    /* .animate__animated.animate__fadeOut {
        --animate-duration: 2s;
    }

    .animate__animated.animate__fadeIn {
        --animate-duration: 2s;
    }   */



</style>